//
//
//
//
//
//
//
//
//
//
//
//
//
//

import debug from 'debug'

import TransitionExpand from '@/components/transitions/TransitionExpand'

const log = debug('FaqItem')

export default {
  name: 'FaqItem',
  components: { TransitionExpand },
  props: {
    active: {
      default: false,
      type: Boolean,
    },
    question: {
      default: 'Question',
      type: String,
    },
    answer: {
      type: Array,
      default: () => ['Answer'],
    },
  },
  data: () => ({
    showAnswer: false,
  }),
  computed: {
    plusMinus() {
      return this.showAnswer ? 'X' : '+'
    },
  },
  created() {
    if (this.active) {
      this.showAnswer = true
    }
  },
  mounted() {
    log('Mounted')
  },
  methods: {
    clickHandler(e) {
      e.preventDefault()
      e.stopPropagation()
      this.showAnswer = !this.showAnswer
    },
    isArray(text) {
      return Array.isArray(text)
    },
  },
}
